
import { FormItem, FormLabel } from "@/components/ui/form";
import { generateSlug } from "@/lib/utils";

interface Props {
  article?: any;
  currentSlug: string;
}

export default function ArticleEditorSlug({ article, currentSlug }: Props) {
  return (
    <FormItem>
      <FormLabel className="text-white/90">URL Slug</FormLabel>
      <div className="flex items-center gap-2">
        <div className="text-sm bg-black/30 border border-white/10 rounded px-3 py-2 w-full overflow-x-auto whitespace-nowrap">
          {currentSlug || (article?.title ? generateSlug(article.title) : "generated-after-save")}
        </div>
        {!article && (
          <div className="text-xs text-white/50">
            Auto-generated from title
          </div>
        )}
      </div>
    </FormItem>
  );
}
